import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useAppContext } from "../AppContext";
import MenuItem from "@mui/material/MenuItem";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { axios_tenant, RedirectTenantLogin } from "../../../../axios";
import { toast } from "react-toastify";

function UploadFile({ fetchFolderContents, handleClose, setUploadPopups }) {
    const appData = useAppContext();
    const [filesToUpload, setFilesToUpload] = useState([]);
    const [isUploadInProgress, setUploadInProgress] = useState(false);

    const handleFileInputChange = e => {
        // "txt","pdf","jpg","jpeg","png","csv","xlsx","zip","docx","doc"
        const acceptedFileFormats = ["application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-outlook","application/zip","application/x-zip-compressed", "text/plain", "text/csv", "image/png", "application/pdf", "image/jpeg", "application/msword","text/xml"];
        const selectedFiles = e.target.files;

        Array.from(selectedFiles).forEach((item)=>{
            if (item?.name?.split(".")?.pop()?.toLowerCase()==="msg"){
                 setFilesToUpload((prevFiles) => [...prevFiles, item]);
            } else {
                 const fileType = item.type;
                if (fileType && acceptedFileFormats.includes(fileType)){
                    setFilesToUpload((prevFiles) => [...prevFiles, item]);
                } else{
                toast.error(`${item.name} - The file format of this file is not accepted`);
                }
            }
           
        })

        e.target.value = null;

    };
    const MAX_FILE_SIZE = 1024 * 1024 * 1024;

    const handleFileUpload = () => {
        if (filesToUpload?.length > 0) {
            const uploadLabel =
                filesToUpload.length === 1
                    ? filesToUpload[0].name
                    : `${filesToUpload.length} files`;

            const popupId =
                `${Date.now()}-${Math.random().toString(36).substring(2,9)}`;

            setUploadPopups((prev) => [
                ...prev,
                {
                    id: popupId,
                    status: "uploading",
                    fileName: uploadLabel,
                },
            ]);

            const files = [...filesToUpload];

            setUploadInProgress(true);

            setFilesToUpload([]);

            handleClose();

            const uploadPromises = files.map((file) => {
              
                    const fileSize = file.size;

                    if (fileSize <= MAX_FILE_SIZE) {
                        const formData = new FormData();
                        formData.append("files", file);
                        formData.append("folderId", appData.folderId);
                        return axios_tenant.post(
                            "/collaboration/createFile",
                            formData,
                            {   
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                                silent: true
                            }
                        )
                        .catch((error) => {

                            // Timeout
                            if (
                                error.code === "ECONNABORTED" ||
                                error.message?.toLowerCase().includes("timeout")
                            ) {
                                toast.error("Request timed out. Please try again.");
                            }

                            // Network / Connection Reset
                            else if (
                                error.code === "ERR_NETWORK" ||
                                error.code === "ECONNRESET" ||
                                error.message?.toLowerCase().includes("network error") ||
                                !error.response
                            ) {
                                toast.error("Connection error. Please check your network and try again.");
                            }

                            // Backend response
                            else if (error.response) {

                                if (error.response.status === 401) {
                                    RedirectTenantLogin();
                                    throw error;
                                }

                                const status = error.response.status;

                                const message =
                                    error.response.data?.message ||
                                    error.response.data?.error ||
                                    "Something went wrong.";

                                toast.error(`${status}: ${message}`);
                            }

                            // Fallback
                            else {
                                toast.error("Unexpected error occurred.");
                            }
                            throw error;

                        });
                    }else {
                        toast.error("Maximum file size is 1 GB.");
                        return Promise.reject(new Error("File exceeds maximum size."));
                    }
            });

            Promise.allSettled(uploadPromises)
                .then((results) => {
                    setUploadInProgress(false);
                    const anyFailed = results.some(r => r.status === "rejected");
                    const allFailed = results.every(r => r.status === "rejected");

                    let popupStatus = "success";

                    if (allFailed) {
                        popupStatus = "error";
                    } else if (anyFailed) {
                        popupStatus = "partial";
                    }

                    setUploadPopups((prev) =>
                        prev.map((popup) =>
                            popup.id === popupId
                                ? {
                                    ...popup,
                                    status: popupStatus,
                                }
                                : popup
                        )
                    );

                    if (!allFailed) {
                        fetchFolderContents();
                    }

                    setTimeout(() => {
                        setUploadPopups((prev) =>
                            prev.filter((popup) => popup.id !== popupId)
                        );
                    }, 2000);
                });
        }
    };

    const handleCloseDialog = () => {
        setFilesToUpload([]);
        handleClose();
    };

    return (
        <>
            <input id="upload-file" style={{ display: "none" }} type="file" onChange={handleFileInputChange} accept=".txt,.pdf,.jpg,.jpeg,.png,.csv,.xlsx,.zip,.docx,.doc,.xml,.MSG,.msg" multiple />
            <MenuItem component="span">
                <label htmlFor="upload-file">
                    <FileUploadIcon style={{ marginRight: 8, color: "#676773" }} />
                    Upload File(s)
                </label>
            </MenuItem>

            <Modal
                open={filesToUpload.length > 0}
                onClose={!isUploadInProgress ? handleCloseDialog:()=>{}}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <Box
                    sx={{
                        width: "30%",
                        bgcolor: "white",
                        p: 2,
                        overflowY: "auto",
                        maxHeight: "70vh"
                    }}
                    onKeyDown={(e) => { if (e.key === "Enter" && !isUploadInProgress ) handleFileUpload(); }}
                    tabIndex={0}
                >
                    <div style={{ fontWeight: "bold" }}>Upload Files</div>
                    {filesToUpload.map((file) => (
                        <div
                            key={`${file.name}-${file.lastModified}`}
                            style={{ padding: 8, wordWrap: "break-word" }}
                        >
                            {file.name}
                        </div>
                    ))}
                    {!isUploadInProgress && (
                        <div style={{ textAlign: "right" }}>
                            <Button style={{ backgroundColor: "orange", color: "white", textTransform: "none" }} variant="contained" color="primary" onClick={handleFileUpload}>
                                Upload
                            </Button>
                        </div>
                    )}
                </Box>
            </Modal>
        </>
    );
}

export default UploadFile;